import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import * as moment from "jalali-moment";
import { MatPaginator, MatSelect } from "@angular/material";
import { ICompany } from "src/app/interfaces/company";
import { IRegister } from "src/app/interfaces/register";
import { ErrorsService } from "src/app/services/common/errors.service";
import { InvoiceService } from "src/app/services/http/business/invoice/invoice.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { AccountService } from "src/app/services/http/business/account/account.service";
import { CIDService } from "src/app/services/common/cid.service";
import { PaymentService } from "src/app/services/http/business/payment/payment.service";
import { RefoundEntryComponent } from "./refound-entry/refound-entry.component";
//import { Router } from "@angular/router";
import { InvoiceSummaryComponent } from "../../payment/invoice-summary/invoice-summary.component";
//import { BIDService } from "src/app/services/common/bid.service";
import { InvoiceSearchComponent } from "../invoice-search/invoice-search.component";
import { environment } from "src/environments/environment";
import { InvoiceDetailsComponent } from "../invoice-details/invoice-details.component";
//import { BIDService } from "src/app/services/common/bid.service";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { IConfirm } from "src/app/interfaces/confirm";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { IBranch } from "src/app/interfaces/branch";
import { HttpHeaders } from "@angular/common/http";
import { PlacementService } from "src/app/services/http/business/placement/placement.service";
import { PlacementDetailComponent } from "src/app/pages/student/student-placement/placement-detail/placement-detail.component";
import { BIDService } from "src/app/services/common/bid.service";

@Component({
  selector: "app-invoice-list",
  templateUrl: "./invoice-list.component.html",
  styleUrls: ["./invoice-list.component.css"]
})
export class InvoiceListComponent implements OnInit {
  invoiceList: any;
  isOwner: boolean;
  cid: string;
  filter: any;
  branchList: IBranch[];
  BranchEncryptId: string;
  companyList: ICompany;
  companySelected: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: any = [];
  displayedColumns: string[] = [
    "invoiceCode",
    "invoiceType",
    "title",
    "creationDateInvoice",
    "payPerson",
    "price",
    "remaining",
    // "priceDiscount",
    "invoiceStatus",
    "function",
    "placement"
  ];
  pageSize: number;
  pageIndex: number;
  userInfo: IRegister;

  constructor(
    //private router: Router,
    private dialog: MatDialog,
    private cidService: CIDService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private paymentService: PaymentService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private placementService: PlacementService,
    private invoiceService: InvoiceService,
    private holdingService: HoldingService,
    private accountService: AccountService,
    private snackBar: SnackBarService,
    private bidService: BIDService
  ) { }

  ngOnInit() {
    this.getCompanyList();
    this.checkOwner();

    // this.companySelected = this.cidService.getCID();
  }

  checkOwner() {

    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (!res.IsOwner)
        this.getInvoices(this.bidService.getBID())
      // if (res.IsOwner) {
      //   this.getCompanyList();
      //   if (this.cidService.getCID) {
      //     //this.getInvoices();
      //   }
      //   this.getInvoices(this.bidService.getBID());
      // }
      // else {
      //   this.BranchEncryptId = this.bidService.getBID();
      //   this.getInvoices(this.bidService.getBID());
      //   //this.getBranchInvoices();
      // }
    });
  }

  search() {
    this.dialog
      .open(InvoiceSearchComponent, {
        width: '550px',
        data: null
      })
      .afterClosed()
      .subscribe(res => {
        console.log(res);

        this.filter = res;
        if (this.isOwner)
          this.getInvoices(res.BranchEncryptId);
        else
          this.getInvoices(this.bidService.getBID());

      });
  }

  detailsInvoice(item: any) {
    this.dialog
      .open(InvoiceDetailsComponent, {
        width: '75%',
        data: item
      })
      // .afterClosed()
      // .subscribe(res => {
      //
      //   console.log(res);
      //   this.filter = res
      //    this.getInvoices();

      // })
      ;
  }

  paginatorEvent(event) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    if (this.isOwner)
      this.getInvoices(this.BranchEncryptId);
    else
      this.getInvoices(this.bidService.getBID());
    // if (this.isOwner) {
    //   this.invoiceService
    //     .invoiceCompanyAll(this.filter, event.pageIndex + 1, event.pageSize)
    //     .subscribe(res => {
    //       this.pageSize = event.pageSize;
    //       this.pageIndex = event.pageIndex + 1;
    //       this.dataSource = res.DataList;
    //       this.paginator.length = res.Total;
    //     });
    // }
    // else {
    //   this.invoiceService.invoiceCompany(this.filter, event.pageIndex + 1, event.pageSize).subscribe(res => {
    //     this.pageSize = event.pageSize;
    //     this.pageIndex = event.pageIndex + 1;
    //     this.dataSource = res.DataList;
    //     this.paginator.length = res.Total;
    //   });
    // }
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(
      res => {
        this.companyList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }
  setCid(e: MatSelect) {
    if (this.isOwner) {
      this.cidService.setCID(e.value);
      this.cid = e.value;
    }
    this.dataSource = null;
    this.getBranchList(e.value);
  }
  getBranchList(company) {

    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );

    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(res => {
      this.branchList = res.DataList;
    });
  }

  loadData(e: MatSelect) {
    this.dataSource = null;
    this.BranchEncryptId = e.value
    this.getInvoices(e.value);
    // if (this.isOwner) {
    //   this.bidService.setBID(e.value);
    // }
    // else {
    //   this.BranchEncryptId = e.value;
    // }

  }

  getInvoices(branch) {
    if (this.filter && this.filter.CreationDateInvoiceStart) {
      //for moment CreationDateInvoiceStart change format
      this.filter.CreationDateInvoiceStart = moment
        .from(this.filter.CreationDateInvoiceStart, "en")
        .utc(true)
        .format(environment.dateFormat);
      //.toJSON();

      //with moment CreationDateInvoiceEnd change format
      this.filter.CreationDateInvoiceEnd = moment
        .from(this.filter.CreationDateInvoiceEnd, "en")
        .utc(true)
        .format(environment.dateFormat);
      //.toJSON();
    }
    // if (this.isOwner) {
    //   this.invoiceService.invoiceCompanyAll(this.filter, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
    //     this.dataSource = res.DataList;
    //     this.paginator.length = res.Total;
    //     this.paginator.pageIndex = 0;
    //     this.paginator.pageSize = 10;
    //   });
    // }
    // else {
    if (this.filter) {
      if (this.isOwner)
        this.filter.BranchEncryptId = branch;
      else
        this.filter.BranchEncryptId = this.bidService.getBID();
    }
    else {
      if (this.isOwner)
        this.filter = { BranchEncryptId: branch };
      else
        this.filter = { BranchEncryptId: this.bidService.getBID() };
    }
    this.invoiceService.invoiceCompany(this.filter, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      // this.paginator.pageIndex = 0;
      // this.paginator.pageSize = 10;
    });
    // }

  }



  getFullName(naCode: string) {
    this.accountService.getSimpleUserInfo(naCode).subscribe(res => {
      if (res.FullName) {
        return res.FullName;
      }
    });
  }

  placementDetails(e) {
    var _filter = {
      Id: e.SourceId
    };
    this.placementService.list(_filter, null, 1, 10).subscribe(res => {
      this.dialog
        .open(PlacementDetailComponent, {
          data: res.DataList[0],
          width: '400px'
        });

    });
  }
  pay(e) {
    if (e.Price == 0) {
      let data = {
        ListCouponId: [],
        CompanyDiscount: 0,
        Id: e.Id
      }
      this.paymentService.pay(data, 'melli').subscribe(() => {
        this.dataSource = null;
        this.getInvoices(this.BranchEncryptId);
      });
    } else {
      //this.bidService.setBID()
      this.dialog.open(InvoiceSummaryComponent, {
        width: '98%',
        data: { Id: e.Id }
      })
        .afterClosed()
        .subscribe(() => {
          this.getInvoices(this.BranchEncryptId);
          // this.invoiceService.invoiceCompanyAll(this.filter, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
          //   this.dataSource = res.DataList;
          //   this.paginator.length = res.Total;
          // });
        });

      // this.router.navigate(["management/finance/invoiceSummary/" + e.Id]);
    }
  }
  getColor(e) {
    switch (e.InvoiceStatusId) {
      case 50:
        return "custom-chips primary";
      case 51:
        return "custom-chips accent";
      case 52:
        return "custom-chips accent";
      case 53:
        return "custom-chips accent";
      case 54:
        return "custom-chips accent";
      case 55:
        return "custom-chips default";
      default:
        return "custom-chips default";
    }
  }
  refound(e) {
    console.log(e);
    this.dialog.open(RefoundEntryComponent, {
      width: "400px",
      data: e
    })
      .afterClosed()
      .subscribe(() => {
        this.getInvoices(this.BranchEncryptId);
        // this.invoiceService.invoiceCompanyAll(this.filter, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
        //   this.dataSource = res.DataList;
        //   this.paginator.length = res.Total;
        // });
      });
  }

  cancelPayment(e) {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.invoiceCancelConfirm"),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "700px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.invoiceService.cancelInvoice({ Id: e.Id }).subscribe(() => {
            this.snackBar.OpenSnackBar(
              this.translate.get("success.invoiceCanceled"),
              "ok",
              3000,
              SoundEnum.beep
            );
            this.getInvoices(this.BranchEncryptId);
            // this.invoiceService.invoiceCompanyAll(this.filter, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
            //   this.dataSource = res.DataList;
            //   this.paginator.length = res.Total;
            // });
          },
            () => {
              this.snackBar.OpenSnackBar(
                this.translate.get("error.invoiceCanceledFaild"),
                "ok",
                3000,
                SoundEnum.beep
              );
            })

        }
      });


    // console.log(e);
    // this.dialog.open(RefoundEntryComponent, {
    //   width: "400px",
    //   data: e
    // })
    //   .afterClosed()
    //   .subscribe(() => {
    //     this.invoiceService.invoiceCompanyAll(this.filter, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
    //       this.dataSource = res.DataList;
    //       this.paginator.length = res.Total;
    //     });
    //   });
  }

}
